<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <money
      :ref="`ref${name}`"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :min="0"
      :max="5"
      :class="retornaEstiloInput()"
      v-model.lazy="valor"
      v-bind="money"
      @input="onStateMoedaInput($event, 'onInput')"
      autocomplete="off" />
      <!-- v-if="!campoComValorValido()" -->
    <div
      class="invalid-feedback">
      {{ retornaMensagemDeErro() }}
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'
import InputBaseMixins from './mixins/InputBaseMixins'

export default {
  name: 'InputMoeda',
  mixins: [InputBaseMixins],
  components: {
    Money,
  },
  data() {
    return {
      ultimoValor: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
    }
  },
  methods: {
    onStateMoedaInput(evt, estado) {
      if (evt !== this.ultimoValor) {
        this.ultimoValor = evt
        this.$emit(estado, evt)
      }
    },
    campoComValorValido() {
      return this.verificaEstadoInput() !== false
    },
    retornaEstiloInput() {
      return !this.campoComValorValido()
        ? 'form-control is-invalid'
        : 'form-control'
    },
  },
}

</script>
